<template>
  <b-col
    align-self="center"
    class="tw-flex tw-flex-col tw-mx-auto"
  >
    <h1 class="question-title-v2 tw-text-center tw-mb-5">
      {{ question.question }}
    </h1>

    <div class="tw-flex tw-flex-wrap tw-justify-center tw-gap-4">
      <label
        v-for="(item, i) in question.answerlist"
        :key="item.name + i"
        :for="item.name + question.id"
        class="tw-flex tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-gray-300 tw-cursor-pointer tw-transition-colors hover:tw-border-gray-500 tw-w-28 tw-h-28"
        :class="answer === item.id ? 'tw-border-lavender-purple tw-border-2' : ''"
      >
        <input
          :id="item.name + question.id"
          v-model="answer"
          type="radio"
          :value="item.id"
          :name="`radiolist-${question.id}`"
          class="tw-sr-only"
          @change="onChange(item.id, item)"
        >
        <span class="tw-text-sm">{{ item.name }}</span>
      </label>
    </div>

    <div
      v-if="hasAnswer && !composite"
      class="tw-text-center tw-mt-6"
    >
      <b-button
        variant="info"
        size="lg"
        @click="onContinue"
      >
        Continue
      </b-button>
    </div>
  </b-col>
</template>

<script>
export default {
  props: {
    question: {
      type: Object,
      required: true
    },
    composite: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      answer: null
    };
  },
  computed: {
    hasAnswer() {
      return Object.prototype.hasOwnProperty.call(this.question, 'answer');
    },
  },
  watch: {
    question: {
      handler() {
        this.answer = this.question.answer ?? null;
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    onChange(id, item) {
      this.$emit('submitAnswer', { id: this.question.id, answer: id, answerBody: item });
    },
    onContinue() {
      const item = this.question.answerlist.find(o => o.id == this.answer);
      this.$emit('submitAnswer', { id: this.question.id, answer: this.answer, answerBody: item });
    },
  },
};
</script>
